<template>
  <div :class="classes">
    <pt-page-title title="生命体验馆场次管理"> </pt-page-title>
    <pt-sub-title title="请选择需要取消展览的日期场次"></pt-sub-title>
    <div class="block" style="width: fit-content;text-align: right">
      <div style="margin-top: 0.3rem">
        <span class="demonstration"><span class="required">*</span>日期：</span>
        <el-date-picker v-model="date" type="date" placeholder="选择日期">
        </el-date-picker>
      </div>
      <div>
        <span class="demonstration"><span class="required">*</span>场次：</span>
        <el-select
          v-model="session"
          placeholder="请选择"
          style="width: 2.2rem;margin-top: 0.3rem"
        >
          <el-option
            v-for="item in sessions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <el-button
      type="primary"
      @click="cancelReservation"
      style="margin-top: 0.3rem"
      >取消展览</el-button
    >
    <pt-sub-title title="已取消场次"></pt-sub-title>
    <wt-paged-table
      :on-request-data="getTableData"
      :total-size="totalNumber"
      :page-size="pageSize"
      ref="table"
      :isAddPageToRouter="true"
      :refresh="false"
    >
      <el-table :data="tableData" stripe style="width: 100%; margin-top: 20px">
        <el-table-column
          prop="pavilionName"
          label="体验馆名称"
        ></el-table-column>
        <el-table-column prop="date" label="日期"> </el-table-column>
        <el-table-column prop="time" label="场次"> </el-table-column>
        <el-table-column prop="type" label="状态"> </el-table-column>
      </el-table>
    </wt-paged-table>
  </div>
</template>

<script>
const prefixCls = "pt-manage-reservation";

export default {
  name: "pt-manage-reservation",
  computed: {
    classes() {
      return `${prefixCls}`;
    },
    page() {
      return this.$refs.table.page;
    }
  },
  data() {
    return {
      date: "",
      tableData: [],
      session: "",
      totalNumber: 0,
      pageSize: 10,
      sessions: [
        {
          value: "上午 10:00-11:00",
          label: "上午 10:00-11:00"
        },
        {
          value: "下午 14:00-15:00",
          label: "下午 14:00-15:00"
        }
      ]
    };
  },
  mounted() {},
  methods: {
    getTime() {
      this.$store
        .dispatch("getLifeExperienceHallsReservationTime")
        .then(res => {
          this.sessions = [];
          res.map(item => {
            this.sessions.push({
              value: item.id,
              label: item.name
            });
          });
          console.log(this.sessions);
        })
        .catch(err => {
          this.$message.error(err || "取消失败");
        });
    },
    cancelReservation() {
      if (!this.date) {
        this.$message.error("请选择日期");
        return;
      }
      const data = {
        date: this.date.getTime()
      };

      if (this.session) {
        data.generalEnumeration = {
          id: this.session
        };
      }
      this.$confirm("确定取消该场次吗？", "取消提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$store
          .dispatch("createLifeExperienceHallsReservationNotCan", data)
          .then(res => {
            this.$message.success("取消成功");
            this.getTableData();
          })
          .catch(err => {
            this.$message.error(err || "取消失败");
          });
      });
    },
    getTableData(page, next) {
      this.getTime();
      let data = {
        pageable: {
          page: this.page,
          size: this.pageSize,
          sort:['date, desc']
        },
        type: "NOT_CAN"
      };
      this.$store
        .dispatch("getLifeExperienceHallsReservationAdvanced", data)
        .then(res => {
          this.tableData = this.formatData(res.data);
          this.totalNumber = res.totalNumber;
          if (next) {
            next(res.data);
          }
        })
        .catch(err => {
          this.$message.error(err || "获取生命体验馆预约参观信息失败");
        });
    },
    formatData(data) {
      return data.map(item => {
        const formatDateToYYYYMMDD = dateString => {
          const date = new Date(dateString);
          const year = date.getFullYear();
          const month = (date.getMonth() + 1).toString().padStart(2, "0");
          const day = date
            .getDate()
            .toString()
            .padStart(2, "0");
          return `${year}-${month}-${day}`;
        };
        return {
          ...item,
          pavilionName: "中源协和生命体验馆",
          date: formatDateToYYYYMMDD(item.date),
          type: item.type === "NOT_CAN" ? "已取消" : "未取消"
        };
      });
    }
  }
};
</script>

<style scoped lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.block {
  text-align: right;
  width: fit-content;
}
.required {
  color: red;
}
.download-qrcode {
  color: #edbe81;
}
</style>
